import React,{useState,useEffect} from 'react';

import './App.css';
import Landing from './Landing';
import Mobile from "./Mobile"
import Projects from './Projects';
import { Routes, Route, Link } from "react-router-dom";
import CatFollower from './CatFollower';
import SteveRunner from './SteveRunner';
function App() {
  const [width, setWidth]   = useState(window.innerWidth);
const [height, setHeight] = useState(window.innerHeight);
const updateDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
}
useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
}, []);
  return (
    <div>
       <CatFollower />
       <SteveRunner />
    {width>768?<Routes>
      
        <Route path="/" element={<Landing />} />
        <Route path="/projects" element={<Projects/>} />

        <Route path="*" element={<Landing />} />
      </Routes>:<Mobile/>}
    </div>
  );
}

export default App;
